export const documentTypes = [
  'appointment-confirmation',
  'attempted-delivery',
  'authorization-for-special-service',
  'contact-time-critical',
  'corrected-bol',
  'customs-documents',
  'delivery-manifest',
  'delivery-photo',
  'delivery-return-receipt',
  'detention-certificate',
  'dimension-certificate',
  'freight-forwarding-delivery-order',
  'inspection-certificate',
  'invoice',
  'letter-of-authority',
  'lumper-certificate',
  'nmfc-certificate',
  'other',
  'packing-slip',
  'partner-bill-of-lading',
  'pickup-photo',
  'preliminary-invoice',
  'proof-of-delivery',
  'no-freight-certificate',
  'reconsignment-authorization',
  'refused-delivery-receipt',
  'research-certificate',
  'signed-bol',
  'storage-certificate',
  'storage-notification',
  'tally-record-signature',
  'volume-certificate',
  'weight-and-research-inspection',
  'weight-cert',
  'weights-and-corrections',
  'weights-and-research-photos',
] as const

export type DocumentType = (typeof documentTypes)[number]
